import { PayloadAction } from "@reduxjs/toolkit";
import { put, call, takeLatest, all, select } from "redux-saga/effects";

import { ILocale, commonMessages } from "infrastructure/localization";
import { notification } from "infrastructure/notification";
import { glossaryMessages } from "ui/screens/plex-dictionary/plex-dictionary.localization";
import { applyPickerFilter, IPickerSearchCriterion } from "ui/shared/helpers/plex-components";
import { IIndustry } from "ui/shared/models/common";

import { translationHistoryActions } from "./TranslationHistory.actions";
import { getTermsTranslationHistory, getLocales, getIndustries } from "./TranslationHistory.api";
import { ITranslationHistoryState } from "./TranslationHistory.state";

function* loadTranslationHistoryExecute() {
  try {
    const translationHistory = yield select((state: { translationHistory: ITranslationHistoryState }) => state.translationHistory);
    const data = yield call(getTermsTranslationHistory, { termId: translationHistory.termId, filter: translationHistory.filter.data });

    yield put(translationHistoryActions.loadTranslationHistoryCompleted(data));
  } catch (e) {
    yield put(translationHistoryActions.loadTranslationHistoryError(notification.error(e).useMessageId(glossaryMessages.error("loadTranslationHistoryFailed"))));
  }
}

function* loadIndustriesExecute({ payload }: PayloadAction<IPickerSearchCriterion<IIndustry>>) {
  try {
    let industries: IIndustry[] = yield call(getIndustries, payload.query.query);
    industries = applyPickerFilter(industries, payload, row => row.description);

    yield put(translationHistoryActions.loadIndustriesCompleted(industries));
  } catch (e) {
    yield put(translationHistoryActions.loadTranslationHistoryError(notification.error(e).useMessageId(glossaryMessages.error("loadIndustriesFailed"))));
  }
}

function* loadLocalesExecute({ payload }: PayloadAction<IPickerSearchCriterion<ILocale>>) {
  try {
    let locales: ILocale[] = yield call(getLocales, payload.query.query);
    locales = applyPickerFilter(locales, payload, row => row.name);
    applyPickerFilter(locales, payload, row => row.localeIdentifier);

    yield put(translationHistoryActions.loadLocalesCompleted(locales));
  } catch (e) {
    yield put(translationHistoryActions.loadTranslationHistoryError(notification.error(e).useMessageId(commonMessages.error("loadLocalesFailed"))));
  }
}

function* applyTranslationHistoryFilterExecute() {
  yield put(translationHistoryActions.loadTranslationHistory());
}

function* actionWatcher() {
  yield takeLatest(translationHistoryActions.loadTranslationHistory.toString(), loadTranslationHistoryExecute);
  yield takeLatest(translationHistoryActions.applyTranslationHistoryFilter.toString(), applyTranslationHistoryFilterExecute);
  yield takeLatest(translationHistoryActions.loadLocales.toString(), loadLocalesExecute);
  yield takeLatest(translationHistoryActions.loadIndustries.toString(), loadIndustriesExecute);
}

export function* translationHistorySaga() {
  yield all([actionWatcher()]);
}
